import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BookDemoAnchor } from "@/components/BookDemoAnchor";
import { useRotatingCTA } from "@/hooks/useRotatingCTA";

/** "Ready to try Bidmio?" band at the top of the footer. */
const FooterCtaBand = () => {
  const { t } = useTranslation();
  const { getAppUrl } = useRotatingCTA(false);

  return (
    <div
      className="mb-12 flex flex-col gap-5 rounded-2xl bg-background/[0.07] p-6 sm:p-8 lg:flex-row lg:items-center lg:justify-between"
      data-testid="footer-cta-band"
    >
      <div className="space-y-2">
        <h2 className="text-xl font-bold sm:text-2xl">{t("layout.footer.cta.title")}</h2>
        <p className="text-background/70">{t("layout.footer.cta.subtitle")}</p>
      </div>
      <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
        <a
          href={getAppUrl()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="button-footer-cta-primary"
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-lg bg-primary px-5 font-semibold text-primary-foreground transition-colors hover:bg-primary-hover"
        >
          {t("layout.footer.cta.primary")}
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </a>
        <BookDemoAnchor
          source="footer-cta"
          data-testid="button-footer-cta-demo"
          className="inline-flex min-h-12 items-center justify-center rounded-lg border border-background/40 px-5 font-semibold text-background transition-colors hover:bg-background/10"
        >
          {t("layout.footer.quickLinks.demo")}
        </BookDemoAnchor>
      </div>
    </div>
  );
};

export default FooterCtaBand;
